export const scrollToParentTop = () => {
    window.parent.postMessage({ type: 'scrollToTop' }, '*');
};

export const updateHeight = () => {
    const body = document.getElementsByTagName('body')[0];
    const height = body.scrollHeight;
    window.parent.postMessage({ type: 'heightChange', height, isMobile: true }, '*');
};

export const activateBot = (url: string) => {
    let message = { type: 'sa-activateBot', url };
    window.parent.postMessage(message, '*');
};
